<template>

    <v-card
            v-if="information == null || information.lastModifiedDate == null "
            outlined
            class="mx-auto"
            style="width: 400px; height: 300px; justify-content: center;"
            align="center"
    >
        <v-skeleton-loader
                ref="skeleton"
                type="card"
                class="mx-auto"
        >
        </v-skeleton-loader>
    </v-card>
    <v-card
            v-else
            outlined
            class="mx-auto"
            max-width="800"
            max-height="500"
    >
        <v-img
                @click="openProject()"
                style="cursor:pointer;"
                :src="img"
                max-width="800"
                max-height="300"
        >

            <slot name="chips">
                <v-row justify="end" style="margin-right: 1px">
                    <v-chip
                            v-if="showDelete"
                            class="ma-2"
                            color="red"
                            text-color="white"
                            style="margin-right: 10px;"
                            small
                    >
                        Deleted
                    </v-chip>
                    <v-chip
                            v-if="checkNewChip"
                            class="ma-2"
                            color="red"
                            text-color="white"
                            style="margin-right: 10px; width: auto; height: 20px; font-size: 10px; font-weight:bold; "
                            small
                    >
                        NEW
                    </v-chip>
                    <v-chip
                            v-if="displayChip"
                            class="ma-2"
                            :color="displayChip.color"
                            text-color="white"
                            small
                            style="width: auto; height: 20px; font-size: 10px; font-weight:bold;"
                    >
                        {{displayChip.display}}
                    </v-chip>
                    <v-chip
                            v-if="information.shared && information.location == 'mine'"
                            class="ma-2"
                            color="orange"
                            text-color="white"
                            small
                    >
                        shared
                    </v-chip>
                </v-row>
            </slot>

        </v-img>

        <v-list-item three-line>
            <v-list-item-content style="max-width:20%; margin-left: 1%; margin-right: 3%;">
                <div style=" text-align: center; margin-top:30%;">
                    <div style="height: 50px; cursor:pointer;">
                        <v-avatar
                                size="40"
                                @click="enterUserInfo()"
                        >
                            <div v-if="information.authorProfile" style="width: 100%;height: 100%;">
                                <img
                                        :src="information.authorProfile"
                                >
                            </div>
                            <div v-else>
                                <v-icon x-large>mdi-account-circle</v-icon>
                            </div>
                        </v-avatar>
                    </div>
                    <div style="width: 100%;height: 100%; font-size: small;">{{ hiddenEmail }}</div>
                </div>
            </v-list-item-content>
            <v-list-item-content v-bind:style="showDelete ? 'text-decoration-line: line-through;': ''">
                <v-list-item-title class="headline mb-1">{{ projectName }}
                </v-list-item-title>
                <v-list-item-subtitle>Created Date : {{createdTime }}
                </v-list-item-subtitle>
                <v-list-item-subtitle>LastModified Date : {{ lastModifiedTime }}
                </v-list-item-subtitle>
                <v-list-item-subtitle>Comment : {{information.comment}}</v-list-item-subtitle>
            </v-list-item-content>
        </v-list-item>
        <v-card-actions style="height:36px;">
            <slot name="action" :project="information">
                <v-btn style="position:absolute; right:15%; bottom:5px;"
                       v-if="showDeleteBtn"
                       :disabled="showDelete"
                       color="red"
                       text
                       @click="deleteListsPage()"
                >
                    Delete
                </v-btn>

                <v-btn style="position:absolute; right:5px; bottom:5px;"
                       text
                       :disabled="showDelete"
                       :to="enterUrl()">
                    {{enterText}}
                </v-btn>
            </slot>
        </v-card-actions>
    </v-card>

</template>

<script>
    import CommonStorageBase from "../CommonStorageBase";

    export default {
        name: "list-card",
        mixins: [CommonStorageBase],
        props: {
            information: {
                type: Object,
                default: function () {
                    return null
                }
            },
            readOnly: {
                type: Boolean,
                default: function () {
                    return false
                }
            },
            isLocalModel: {
                type: Boolean,
                default: function () {
                    return false
                }
            }
        },
        data() {
            return {
                showDelete: false,
            }
        },
        created() {
            this.setUserInfo()
            this.checkUserPicture()
        },
        computed: {
            showDeleteBtn() {
                var me = this
                if (!me.readOnly) {
                    if (me.information.author == me.userInfo.uid || !me.information.isServerProject)
                        return true
                }
                return false
            },
            projectName() {
                return this.information.projectName
            },
            img() {
                return this.information.img ? this.information.img : 'https://user-images.githubusercontent.com/54785805/125735022-10b4560f-51c3-4d0d-8c05-9641c6d8a8b0.png'
            },
            authorName() {
                return null
            },
            hiddenEmail() {
                return this.information.authorEmail ? this.information.authorEmail.split('@')[0] : 'undefined'
            },
            createdTime() {
                return this.information.date ? this.convertTimeStampToDate(this.information.date) : ''
            },
            lastModifiedTime() {
                return this.information.lastModifiedDate ? this.convertTimeStampToDate(this.information.lastModifiedDate) : ''
            },
            enterText() {
                var me = this
                if (me.readOnly) {
                    return 'View'
                } else {
                    if (me.information.author == localStorage.getItem('uid')) {
                        return 'Edit'
                    }
                    return 'Join'
                }
            },
            checkNewChip() {
                var me = this
                var yesterdayTimeStamp = Date.now() - (1 * 24 * 60 * 60 * 1000)
                if (yesterdayTimeStamp < me.information.lastModifiedDate) {
                    return true
                }
                return false
            },
            displayChip() {
                var me = this
                if (me.information)
                    if (me.information.type == 'k8s') {
                        return {display: 'KUBERNETES', color: 'blue'}
                    } else if (me.information.type == 'bm') {
                        return {display: 'BusinessModel', color: 'orange'}
                    } else if (me.information.type == 'es') {
                        return {display: 'EVENTSTORMING', color: 'green'}
                    } else
                        return null

            },
        },
        mounted() {
            var me = this
            me.$EventBus.$on(`completeDelete_${me.information.projectId}`, function () {
                me.showDelete = true
            })
        },
        methods: {
            async checkUserPicture() {
                var me = this
                var copyInformation = JSON.parse(JSON.stringify(me.information))
                try {
                    if (me.isLocalModel) {
                        if (!copyInformation.authorProfile)
                            copyInformation.authorProfile = localStorage.getItem('picture')
                    } else {
                        if (!copyInformation.authorProfile && copyInformation.author) {
                            copyInformation.authorProfile = await me.getString(`db://users/${copyInformation.author}/profile_picture`)
                        }
                    }
                    if (!me.information.authorProfile || me.information.authorProfile != copyInformation.authorProfile) {
                        me.$emit('updateAuthorProfile', copyInformation, me.isLocalModel)
                    }
                } catch (e) {
                    console.log('checkUserPicture: ', e)
                }

            },
            enterUserInfo() {
                this.$router.push(`/userInfo/${this.information.author}`)
            },
            deleteModelRecovery() {
                console.log('recovery')
            },
            deleteListsPage() {
                this.$emit('delete', this.information)
            },
            openProject() {
                this.$router.push(this.enterUrl())
            },
            enterUrl() {
                var me = this
                var author = me.information.author ? me.information.author : localStorage.getItem('uid')
                var projectId = me.information.projectId

                if (!me.information.isServerProject) {
                    author = localStorage.getItem('uid')
                }

                if (me.information.type == 'es') {
                    return `/storming/${author}/${projectId}`
                } else if (me.information.type == 'k8s') {
                    return `/kubernetes/${author}/${projectId}`
                } else if (me.information.type == 'bm') {
                    return `/business-model-canvas/${author}/${projectId}`
                }

            },
            convertTimeStampToDate(timeStamp) {
                if (typeof timeStamp == 'string')
                    timeStamp = Number(timeStamp)
                var date = new Date(timeStamp);
                return date.getFullYear() + "년 " + (date.getMonth() + 1) + "월 " + date.getDate() + "일 " + date.getHours() + "시 " + date.getMinutes() + "분"
            },

        },
    }

</script>